import { Form, Formik } from "formik";
import FormControl from "@mui/material/FormControl";
import { TextField, CircularProgress, Tabs, Tab, Typography  } from "@mui/material";
import SearchComponent from "../../../components/OB/SearchComponent";
import TableComponent from "../../../components/OB/TableComponent";
import { useState } from "react";
import SicilAramaAPI, { SicilAramaRequest } from "../../../apis/OB/Get/SicilAramaAPI";
import { showToast } from "../../../helpers/ToastifyHelper";
import * as Yup from "yup";
 
const validationSchema = Yup.object({
  vatandaslikNo: Yup.string().when('aktifTabIndex', {
    is: 0,
    then: s => s.required("T.C. Kimlik No zorunludur"),
    otherwise: s => s
  }),
  adi: Yup.string().when('aktifTabIndex', {
    is: 0,
    then: s => s.required("Ad zorunludur"),
    otherwise: s => s
  }),
  soyadi: Yup.string().when('aktifTabIndex', {
    is: 0,
    then: s => s.required("Soyad zorunludur"),
    otherwise: s => s
  }),
  babaAdi: Yup.string().when('aktifTabIndex', {
    is: 0,
    then: s => s.required("Baba adı zorunludur"),
    otherwise: s => s
  }),
 // Kurumsalda sadece vergiNo zorunlu
  vergiNo: Yup.string().when('aktifTabIndex', {
    is: 1,
    then: s => s.required("Vergi No zorunludur"),
    otherwise: s => s
  }),
  unvan: Yup.string() // opsiyonel
});
 
 
const SicilArama: React.FC = () => {
  const [vatandaslikNo, setVatandaslikNo] = useState("");
  const [adi, setAdi] = useState("");
  const [soyadi, setSoyadi] = useState("");
  const [babaAdi, setBabaAdi] = useState("");
  const [nufusCuzdanSeriNo, setnufusCuzdanSeriNo] = useState("");
 
  const [vergiNo, setVergiNo] = useState("");
  const [unvan, setUnvan] = useState("");
 
  const [data, setData] = useState<any[]>([]);
  const [isSearched, setIsSearched] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [searchControl, setSearchControl] = useState<boolean>(true);
  const [aktifTabIndex, setAktifTabIndex] = useState(0);
 
  // Bireysel için kolonlar
  const bireyselColumns = [
    { header: "Sicil Kodu", field: "sicilKodu", className: "text-center" },
    { header: "Adı", field: "adi", className: "text-center" },
    { header: "Soyadı", field: "soyadi", className: "text-center" },
    { header: "T.C. Kimlik No", field: "vatandaslikNo", className: "text-center" },
    { header: "Baba Adı", field: "babaAdi", className: "text-center" },
    { header: "Unvan", field: "unvan", className: "text-center" },
    { header: "Vergi No", field: "vergiNo", className: "text-center" },
    { header: "Nüfus Cüzdan Seri No", field: "nufusCuzdanSeriNo", className: "text-center" },
    { header: "Doğum Tarihi", field: "dogumTarihi", className: "text-center" },
  ];
 
  // Kurumsal için kolonlar
  const kurumsalColumns = [
    { header: "Sicil Kodu", field: "sicilKodu", className: "text-center" },
    { header: "Unvan", field: "unvan", className: "text-center" },
    { header: "Vergi No", field: "vergiNo", className: "text-center" },
  ];
 
  // Aktif tab'a göre kolonları seç
  const columns = aktifTabIndex === 0 ? bireyselColumns : kurumsalColumns;
 
  const fetchData = async () => {
    if (aktifTabIndex === 0) {
      if (!vatandaslikNo || !adi || !soyadi || !babaAdi || !nufusCuzdanSeriNo) {
        showToast("Lütfen tüm alanları doldurun!", "error");
        setSearchControl(false);
        return;
      }
    }
    else{
        if (!vergiNo) {
        showToast("Lütfen vergi no alanını doldurun!", "error");
        setSearchControl(false);
        return;
      }
    }
 
 
    try {
      setIsLoading(true);
      let req: SicilAramaRequest;
      if (aktifTabIndex === 0) {
        // Bireysel
        req = new SicilAramaRequest(
          adi,
          soyadi,
          vatandaslikNo,
          babaAdi,
          undefined,
          undefined,
          nufusCuzdanSeriNo,
          undefined
        );
      } else {
        // Kurumsal
        req = new SicilAramaRequest(
          undefined,
          undefined,
          undefined,
          undefined,
          unvan || undefined,
          vergiNo,
          undefined,
          undefined
        );
      }
 
      const response = await SicilAramaAPI.sicilArama(req);
      console.log("API yanıtı:", response);
 
      if (response?.data) {
        setData(response.data);
        setAktifTabIndex(aktifTabIndex);
        setIsSearched(true);
      } else {
        setData([]);
        setIsSearched(true);
        showToast("Kayıt bulunamadı", "warning");
      }
    } catch (err) {
      showToast("Hata oluştu", "error");
      setSearchControl(false);
      setData([]);
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };
 
  const handleTabChange = (_: React.SyntheticEvent, newIndex: number) => {
    setAktifTabIndex(newIndex);
    setSearchControl(true);
    setData([]);
    setIsSearched(false);
  };
 
  const handleTemizle = () => {
    setVatandaslikNo("");
    setAdi("");
    setSoyadi("");
    setBabaAdi("");
    setnufusCuzdanSeriNo("");
    setVergiNo("");
    setUnvan("");
    setData([]);
    setIsSearched(false);
    setSearchControl(true);
  };
 
  return (
    <div className="px-1 px-md-2 px-lg-4 py-3 card w-100">
      <div className="card-body p-0">
        <Tabs
          value={aktifTabIndex}
          onChange={handleTabChange}
          textColor="primary"
          indicatorColor="primary"
          sx={{ mb: 2 }}
        >
          <Tab label="Bireysel" />
          <Tab label="Kurumsal" />
        </Tabs>
 
        {aktifTabIndex === 0 && (
          <Typography
          noWrap
          sx={{ mb: 1, fontSize: "0.85rem", color: "#d42323" }}
          title="Eski kimlik kullanan vatandaşlar seri ve sıra numarasını arada boşluk bırakmadan 'Nüfus Cüzdanı Seri No' alanına yazmalıdır."
          >
            Eski kimlik kullanan vatandaşlar seri ve sıra numarasını sırasıyla arada boşluk bırakmadan ‘Nüfus Cüzdanı Seri No’ alanına yazmalıdır.
          </Typography>
        )}
 
        <Formik
          initialValues={{
            vatandaslikNo: "",
            adi: "",
            soyadi: "",
            babaAdi: "",
            vergiNo: "",
            unvan: "",
            aktifTabIndex
          }}
          validationSchema={validationSchema}
          onSubmit={() => {}}
        >
          <Form id="kayit-form" className="d-flex w-100 mb-4">
            <div className="d-flex flex-column flex-sm-row w-100 gap-3 ml-2 mr-2">
              <div className="d-flex flex-column flex-sm-row gap-2 w-100">
                {aktifTabIndex === 0 && (
                  <>
                    <FormControl sx={{ width: { xs: "100%", sm: "50%", md: "25%" }, minWidth: 140 }}>
                      <TextField
                        label="T.C. Kimlik No"
                        variant="outlined"
                        size="small"
                        value={vatandaslikNo}
                        error={!vatandaslikNo && searchControl === false}
                        color={!vatandaslikNo && searchControl === false ? "error" : "primary"}
                        onChange={(e) => setVatandaslikNo(e.target.value)}
                        sx={{ "& .MuiOutlinedInput-root": { backgroundColor: "white" } }}
                      />
                    </FormControl>
                    <FormControl sx={{ width: { xs: "100%", sm: "50%", md: "25%" }, minWidth: 140 }}>
                      <TextField
                        label="Ad"
                        variant="outlined"
                        size="small"
                        value={adi}
                        error={!adi && searchControl === false}
                        color={!adi && searchControl === false ? "error" : "primary"}
                        onChange={(e) => setAdi(e.target.value)}
                        sx={{ "& .MuiOutlinedInput-root": { backgroundColor: "white" } }}
                      />
                    </FormControl>
                    <FormControl sx={{ width: { xs: "100%", sm: "50%", md: "25%" }, minWidth: 140 }}>
                      <TextField
                        label="Soyad"
                        variant="outlined"
                        size="small"
                        value={soyadi}
                        error={!soyadi && searchControl === false}
                        color={!soyadi && searchControl === false ? "error" : "primary"}
                        onChange={(e) => setSoyadi(e.target.value)}
                        sx={{ "& .MuiOutlinedInput-root": { backgroundColor: "white" } }}
                      />
                    </FormControl>
                    <FormControl sx={{ width: { xs: "100%", sm: "50%", md: "25%" }, minWidth: 140 }}>
                      <TextField
                        label="Baba Adı"
                        variant="outlined"
                        size="small"
                        value={babaAdi}
                        error={!babaAdi && searchControl === false}
                        color={!babaAdi && searchControl === false ? "error" : "primary"}
                        onChange={(e) => setBabaAdi(e.target.value)}
                        sx={{ "& .MuiOutlinedInput-root": { backgroundColor: "white" } }}
                      />
                    </FormControl>
                    <FormControl sx={{ width: { xs: "100%", sm: "50%", md: "25%" }, minWidth: 140 }}>
                      <TextField
                        label="Nüfus Cüzdan Seri No"
                        variant="outlined"
                        size="small"
                        value={nufusCuzdanSeriNo}
                        error={!nufusCuzdanSeriNo && searchControl === false}
                        color={!nufusCuzdanSeriNo && searchControl === false ? "error" : "primary"}
                        onChange={(e) => setnufusCuzdanSeriNo(e.target.value)}
                        sx={{ "& .MuiOutlinedInput-root": { backgroundColor: "white" } }}
                      />
                    </FormControl>
                  </>
                )}
 
                {aktifTabIndex === 1 && (
                  <>
                    <FormControl sx={{ width: { xs: "100%", sm: "50%", md: "25%" }, minWidth: 140 }}>
                      <TextField
                        label="Vergi No"
                        variant="outlined"
                        size="small"
                        value={vergiNo}
                        error={!vergiNo && searchControl === false}
                        color={!vergiNo && searchControl === false ? "error" : "primary"}
                        onChange={(e) => setVergiNo(e.target.value)}
                        sx={{ "& .MuiOutlinedInput-root": { backgroundColor: "white" } }}
                      />
                    </FormControl>
                    <FormControl sx={{ width: { xs: "100%", sm: "50%", md: "25%" }, minWidth: 140 }}>
                      <TextField
                        label="Unvan"
                        variant="outlined"
                        size="small"
                        value={unvan}
                        onChange={(e) => setUnvan(e.target.value)}
                        sx={{ "& .MuiOutlinedInput-root": { backgroundColor: "white" } }}
                      />
                    </FormControl>
                  </>
                )}
              </div>
              <div className="d-flex flex-row ms-auto">
                <SearchComponent fetchData={fetchData} onTemizle={handleTemizle} setData={setData} />
              </div>
            </div>
          </Form>
        </Formik>
 
        {isLoading ? (
          <div className="d-flex w-100 justify-content-center align-items-center" style={{ height: "10rem" }}>
            <CircularProgress />
          </div>
        ) : (
          <TableComponent columns={columns} data={data} recordsPerPage={10} isSearched={isSearched} />
        )}
      </div>
    </div>
  );
};
 
export default SicilArama;
 